import { createFileRoute } from '@tanstack/react-router';

import { HomeworkPage } from '@/features/teacher/HomeworkPage';

export const Route = createFileRoute('/_authed/teacher/homework')({
  validateSearch: (search): { group?: string } => ({
    group: typeof search.group === 'string' ? search.group : undefined,
  }),
  component: HomeworkPage,
});
